export default class TabData {
  constructor(title: String, icon) {
    this.title = title
    this.icon = icon
  }
}
